// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3jLXS","cell":"ColumnAccessor_cell__1ew12","firstCellAccent":"ColumnAccessor_firstCellAccent__11pXr"};